import { useTranslation } from 'react-i18next';
import CentrosBase from './CentrosBase';

const Escolas = () => {

    const { t } = useTranslation();

    return (
        <CentrosBase centroNome={'ESCOLAS'} centroDescricao={t('CentrosBase.escolaDescricao')} 
        tipo={'ESCOLA'} 
        excludedCountries={['PERU', 'URUGUAI']}/>
    );
};

export default Escolas;